export default __webpack_public_path__ + "locales/sq-AL/DeleteDialog.json?hash=0e93aeda918a4b03e3a76a9eafad3133";